<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>Contents</h1>
<p class="tocfmf"><a class="xref" href="#/chiKrinsky0006#abbrev">List of Abbreviations</a></p>
<p class="tocf"><a class="xref" href="#/chiKrinsky0007#ch01"><b>1</b>  Introduction</a></p>
<p class="toc"><a class="xref" href="#/chiKrinsky0008#ch02"><b>2</b>  The Workers</a></p>
<p class="toc"><a class="xref" href="#/chiKrinsky0009#ch03"><b>3</b>  The Work</a></p>
<p class="toc"><a class="xref" href="#/chiKrinsky0010#ch04"><b>4</b>  The Workplace</a></p>
<p class="toc"><a class="xref" href="#/chiKrinsky0011#ch05"><b>5</b>  Public-Private Partnerships</a></p>
<p class="toc"><a class="xref" href="#/chiKrinsky0012#ch06"><b>6</b>  Institutional Boundaries, Accountability, and the Integral State</a></p>
<p class="toc"><a class="xref" href="#/chiKrinsky0013#ch07"><b>7</b>  The Politics of Free Labor: Visibility and Invisibility</a></p>
<p class="toc"><a class="xref" href="#/chiKrinsky0014#ch08"><b>8</b>  Valuing Maintenance, Valuing Workers</a></p>
<p class="tocbmf"><a class="xref" href="#/chiKrinsky0015#aft">Afterword</a></p>
<p class="tocbm"><a class="xref" href="#/chiKrinsky0016#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chiKrinsky0017#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chiKrinsky0018#refs">References</a></p>
<p class="tocbm"><a class="xref" href="#/chiKrinsky0019#index">Index</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-Krinsky-0005.vue?2d5a1021